import { render, staticRenderFns } from "./CategoryFormModal.vue?vue&type=template&id=661b83e8&scoped=true&"
import script from "./CategoryFormModal.vue?vue&type=script&lang=js&"
export * from "./CategoryFormModal.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFormModal.vue?vue&type=style&index=0&id=661b83e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661b83e8",
  null
  
)

export default component.exports